import React, { useState, useEffect, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { ThinCheckbox } from 'components/common/Styles';

const AuthorizationListResponsiveTableRowCell = ({ dispatch, authorization, userGroup, changedPermission }) => {
  const [localValue, setLocalValue] = useState(false);
  const [isRefined, setIsRefined] = useState(false);

  useEffect(() => {
    if (changedPermission !== undefined) setLocalValue(changedPermission.value);
  }, [changedPermission]);

  useEffect(() => {
    if (changedPermission === undefined)
      setLocalValue(authorization.authorizationXUserGroups?.find(x => x.userGroupId === userGroup.id)?.canRead || false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorization.authorizationXUserGroups, userGroup.id]);

  useEffect(() => {
    setIsRefined(authorization.isRefined);
  }, [authorization.isRefined]);

  const onClickExecution = useCallback(
    event => {
      dispatch({
        type: 'OnSetAuthorizationXUserGroupValue',
        authorizationId: authorization.webAuthorizationId,
        userGroupId: userGroup.id,
        value: event.target.checked
      });
    },
    [dispatch, authorization.webAuthorizationId, userGroup.id]
  );

  return (
    <TableCell align='center'>
      <ThinCheckbox checked={localValue} size='small' onClick={onClickExecution} disabled={isRefined} />
    </TableCell>
  );
};

AuthorizationListResponsiveTableRowCell.propTypes = {
  changedPermission: PropTypes.object,
  userGroup: PropTypes.object.isRequired,
  authorization: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default memo(AuthorizationListResponsiveTableRowCell);
